import { IPagination } from 'app/types/common';

export interface IDataImportsState {
  readonly dataImportsById?: any;
  readonly dataImportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectDataImportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddDataImport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationDataImportIds?: string[];
  readonly currentDataImportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IDataImportsSelector extends IDataImportsState {
  readonly currentDataImport?: any;
  readonly currentFormDataImport?: any;
  readonly dataImportsFilteredByTagInSelectFormat?: any;
  readonly dataImportsByIdInSelectFormat?: any;
  readonly dataImportsFilteredByOrganisationInSelectFormat?: any;
}

export enum DataImportsActionTypes {
  GET_ALL_DATA_IMPORTS_REQUESTED = 'redux-app/data-imports/GET_ALL_DATA_IMPORTS_REQUESTED',
  GET_ALL_DATA_IMPORTS_PENDING = 'redux-app/data-imports/GET_ALL_DATA_IMPORTS_PENDING',
  GET_ALL_DATA_IMPORTS_SUCCESS = 'redux-app/data-imports/GET_ALL_DATA_IMPORTS_SUCCESS',
  GET_ALL_DATA_IMPORTS_FAIL = 'redux-app/data-imports/GET_ALL_DATA_IMPORTS_FAIL',
  GET_DATA_IMPORT_REQUESTED = 'redux-app/data-imports/GET_DATA_IMPORT_REQUESTED',
  GET_DATA_IMPORT_PENDING = 'redux-app/data-imports/GET_DATA_IMPORT_PENDING',
  GET_DATA_IMPORT_SUCCESS = 'redux-app/data-imports/GET_DATA_IMPORT_SUCCESS',
  GET_DATA_IMPORT_FAIL = 'redux-app/data-imports/GET_DATA_IMPORT_FAIL',
  UPDATE_DATA_IMPORT_REQUESTED = 'redux-app/data-imports/UPDATE_DATA_IMPORT_REQUESTED',
  UPDATE_DATA_IMPORT_PENDING = 'redux-app/data-imports/UPDATE_DATA_IMPORT_PENDING',
  UPDATE_DATA_IMPORT_SUCCESS = 'redux-app/data-imports/UPDATE_DATA_IMPORT_SUCCESS',
  UPDATE_DATA_IMPORT_FAIL = 'redux-app/data-imports/UPDATE_DATA_IMPORT_FAIL',
  CREATE_DATA_IMPORT_REQUESTED = 'redux-app/data-imports/CREATE_DATA_IMPORT_REQUESTED',
  CREATE_DATA_IMPORT_PENDING = 'redux-app/data-imports/CREATE_DATA_IMPORT_PENDING',
  CREATE_DATA_IMPORT_SUCCESS = 'redux-app/data-imports/CREATE_DATA_IMPORT_SUCCESS',
  CREATE_DATA_IMPORT_FAIL = 'redux-app/data-imports/CREATE_DATA_IMPORT_FAIL',
  DELETE_DATA_IMPORT_REQUESTED = 'redux-app/data-imports/DELETE_DATA_IMPORT_REQUESTED',
  DELETE_DATA_IMPORT_PENDING = 'redux-app/data-imports/DELETE_DATA_IMPORT_PENDING',
  DELETE_DATA_IMPORT_SUCCESS = 'redux-app/data-imports/DELETE_DATA_IMPORT_SUCCESS',
  DELETE_DATA_IMPORT_FAIL = 'redux-app/data-imports/DELETE_DATA_IMPORT_FAIL',
  SELECT_DATA_IMPORT_REQUESTED = 'redux-app/data-imports/SELECT_DATA_IMPORT_REQUESTED',
}

export default null;
